// extracted by mini-css-extract-plugin
export default {"reviewButton":"mark-for-review_reviewButton__r3FbI","active":"mark-for-review_active__uNQi7"};